import axios from 'axios';
import {type ActionTree} from 'vuex';
import TopMessageHandler from '../../../../../library/topMessageHandler';

const actions: ActionTree<EnrolmentMailState, RootState> = {
    fetchInboxUnreadCount({commit}): Promise<any>
    {
        return new Promise((resolve, reject) =>
        {
            axios.get('/employee/enrolment/mail/fetch-inbox-counts').then(({data: {data}}) =>
            {
                commit('update', {
                    inboxUnreadCount: data.inboxUnreadCount,
                });
                resolve(data);
            }).catch(error =>
            {
                TopMessageHandler.error(error.response?.data.message || 'Anzahl der ungelesenen Nachrichten konnte nicht ermittelt werden.');
                reject(error);
            });
        });
    },
};

export default actions;